import { get, post } from '@/plugins/axios'

/**
* 获取店铺收货清关列表
* @param {Object} params
*/
export function getClearanceAddressList () {
  return get('/customer/customer/shop/getClearanceAddressList')
}

/**
* 获取店铺收货地址列表
* @param {Object} params
*/
export function getShippingAddressList () {
  return get('/customer/customer/shop/getShippingAddressList')
}

/**
* 添加收货地址
* @param {Object} params
*/
export function addShipping (data: any) {
  return post('/customer/customer/shop/addShippingAddress', data)
}

/**
* 添加清关地址
* @param {Object} params
*/
export function addClearance (data: any) {
  return post('/customer/customer/shop/addClearanceAddress', data)
}

/**
* 清关地址设为默认
* @param {Object} params
*/
export function setDefaultClearanceAddress (data: any) {
  return post('/customer/customer/shop/setDefaultClearanceAddress', data)
}

/**
* 添加清关地址
* @param {Object} params
*/
export function setDefaultShippingAddress (data: any) {
  return post('/customer/customer/shop/setDefaultShippingAddress', data)
}

/**
* 日文转英文
* @param {Object} params
*/
export function Jp2En (data: any) {
  return post('/goods/translate', data)
}
